const adaptTBankRequestBody = (body) => ({
  pointId: body.pointId[0].id,
  params: {
    mchId: body.mchId,
    terId: body.terId,
    signKey: body.signKey,
  },
});

export default adaptTBankRequestBody;
